__turbopack_context__.v({
  "form-actions": "r8p1QW_form-actions",
  "form-comment": "r8p1QW_form-comment",
  "form-counter": "r8p1QW_form-counter",
  "form-email": "r8p1QW_form-email",
  "form-error": "r8p1QW_form-error",
  "form-error-stars": "r8p1QW_form-error-stars",
  "form-rating-container": "r8p1QW_form-rating-container",
  "success-container": "r8p1QW_success-container",
  "success-info": "r8p1QW_success-info",
});
